import { createGlobalStyle } from 'styled-components'

/**
 * Styles only applied inside the white label native app wrapper.
 *
 * `user-select` and `-webkit-touch-callout` are disabled so that users cannot select text and see the copy/paste callout on mobile app
 * Still keep the input, textarea, select, contenteditable elements selectable and able to see the copy/paste text inputs on mobile app
 */
const AppWebViewStyles = createGlobalStyle`
  body {
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
  }

  input,
  textarea,
  select,
  [contenteditable],
  [contenteditable] * {
    -webkit-user-select: text;
    user-select: text;
    -webkit-touch-callout: default;
  }
`

export default AppWebViewStyles
